import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-wow-consulta-filtros',
  templateUrl: './wow-consulta-filtros.component.html',
  styleUrls: ['../conta-financeira/conta-financeira-consulta.scss'],
})
export class WowConsultaFiltrosComponent {

  @Input() tipoFiltros: string[] = ['ID'];
  @Input() tipoFiltro = 'ID';
  @Output() tipoFiltroChange = new EventEmitter<string>();

  @Input() parametro = '';
  @Output() parametroChange = new EventEmitter<string>();

  @Input() labelParametro = '';
  @Input() parametroMask = '';
  @Input() showParametro = true;

  @Input() showSituacao = false;
  @Input() situacao: boolean | null = null;
  @Output() situacaoChange = new EventEmitter<boolean | null>();

  @Input() showNovo = true;
  @Input() showConsultarPor = true;
  @Input() parametroWide = false;
  /** Mantém filtros e botões na mesma linha (ex.: contas a pagar/receber). */
  @Input() layoutInline = false;

  @Output() consultar = new EventEmitter<void>();
  @Output() novo = new EventEmitter<void>();

  get labelCampo(): string {
    if (this.labelParametro?.trim()) {
      return this.labelParametro;
    }
    return this.tipoFiltro || 'Parâmetro';
  }

  onTipoFiltroChange(valor: string) {
    this.tipoFiltro = valor;
    this.tipoFiltroChange.emit(valor);
  }

  onParametroChange(valor: string) {
    this.parametro = valor;
    this.parametroChange.emit(valor);
  }

  onSituacaoChange(valor: boolean | null) {
    this.situacao = valor;
    this.situacaoChange.emit(valor);
  }
}
